module.exports = require("punycode");